"use client";
import { useState } from "react";

import { signIn, signOut } from "next-auth/react";

import { useRouter } from "next/navigation";
import { hooks } from "@lib/client";
import logjs from "@metrojs/logjs";
import Consts from "@common/config/consts";

const log = new logjs("login/useLogin");

export function useLogin() {
  //  const { data: session, status } = useSession();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  /*
   * 2026-11-04 政美瑠菜
   * 開発者ID・パスワードはクライアントに置かない。環境変数はサーバーの authorize だけが読む。
   */
  const initForm = {};
  const [form, formProps] = hooks.useFormEx(initForm);
  const router = useRouter();
  const login = async (mode) => {
    try {
      setIsLoading(true);
      setError(null);

      log.debug("START login ---");
      /*
       * 2026-11-04 政美瑠菜
       * 別IDで入り直す前に今のクッキーを消す。失敗しても前のセッションでダッシュボードへ戻さない。
       */
      await signOut({ redirect: false });

      log.debug("ログイン処理開始", { login_id: form.login_id });

      const result = await signIn("credentials", {
        login_id: form.login_id,
        password: form.password,
        mode: mode,
        redirect: false,
        callbackUrl: "/dashboard", //Consts.ROUTES.HOME,
      });

      log.debug("ログイン結果", { result });

      if (result?.error) {
        // NextAuthのエラーメッセージを日本語に変換
        let errorMessage = "ログインに失敗しました";

        if (result.error === "CredentialsSignin") {
          errorMessage = "ログインIDまたはパスワードが正しくありません";
        } else if (result.error.includes("ログインIDまたはパスワードが正しくありません")) {
          errorMessage = result.error;
        }

        setError(errorMessage);
        return;
      }

      // ログイン成功時はリダイレクト
      //if (result?.ok) {
      //window.location.href = result.url || "/agreement"; //Consts.ROUTES.HOME;
      //router.push("/agreement"); //Consts.ROUTES.HOME;
      //}
      // ログイン成功時はリダイレクト
      if (result?.ok) {
        // セッション更新を待つため少し待機
        await new Promise((resolve) => setTimeout(resolve, 200));

        // セッションからnextViewを取得
        try {
          const sessionResponse = await fetch("/api/auth/session");
          const sessionData = await sessionResponse.json();
          const nextView = sessionData?.nextView || sessionData?.user?.nextView;

          log.debug("セッション取得結果", { nextView, sessionData });

          // nextViewに基づいてリダイレクト先を決定
          let redirectPath = "/dashboard"; // デフォルト

          log.debug("リダイレクト先決定", { redirectPath, nextView });
          window.location.href = redirectPath;
        } catch (sessionError) {
          log.error("セッション取得エラー", sessionError);
          // セッション取得に失敗した場合はデフォルトのリダイレクト先へ
          window.location.href = "/dashboard";
        }
      }
    } catch (error) {
      log.error("ログインエラー", error);
      setError("ログインに失敗しました");
    } finally {
      setIsLoading(false);
    }
  };

  return [
    {
      ...form,
      error,
      loading: isLoading,
    },
    {
      ...formProps,
      login,
    },
  ];
}
